namespace Portico.Services {
	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;
	import models = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import psga = apigateway.client;
	import psgm = apigateway.models;

	export interface IAuthorizationService {
		getUserProfile(id: number): angular.IPromise<any>;
	}

	@Service('app', 'authorizationService')
	@Inject('$http', '$q', '$window', 'storageService', 'dataService', 'modalService', 'serverConstants', 'porticoEvents', 'sessionService', 'EdgeAuthenticationApi', 'dateService')
	export class AuthorizationService implements IAuthorizationService {
		constructor(protected $http: ng.IHttpService,
			protected $q: ng.IQService,
			protected $window: ng.IWindowService,
			protected storageService: Portico.Services.IStorageService,
			protected dataService: Portico.Services.IDataService,
			protected modalService: Portico.Services.IModalService,
			protected serverConstants: Portico.Models.Interfaces.IServerConstants,
			protected porticoEvents: Portico.Services.IPorticoEvents,
			protected sessionService: Portico.Services.ISessionService,
			protected edgeAuthenticationApi: psga.EdgeAuthenticationApi,
            protected dateService: Portico.Services.IDateService
		) {
		}

		getUserProfile(id: number): angular.IPromise<any> {
			let endpoint = '/api/Authorization/' + id;

			return this.$http.get<any>(endpoint).then((response) => {
				return response.data;
			});
		}
	}
}